import React from 'react';

import { Collapse, TableCell, TableRow } from '@material-ui/core';

import { useAssignResultsState } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { getSkinsRowResult } from '../Utils/getSkinsRowResult';

interface IProps {
  hole: string;
  index: number;
  onClick: (index: number) => () => void;
  collapsedRow?: number;
}

export const ExpandableSkinsTableRow = (props: IProps) => {
  const { hole, index, onClick, collapsedRow } = props;

  const { selectedScoreType, skinsResults, selectedRoundFormat } = useAssignResultsState();

  const holeResults = skinsResults[Number(hole)];

  return (
    <>
      <TableRow
        id={`clickableRowResult-${index}`}
        key={`tableRowResult-${index}`}
        onClick={onClick(index)}
      >
        <TableCell className="index">{Number(hole) + 1}</TableCell>
        <TableCell className="playerName">{`${holeResults.length} players tied`}</TableCell>
        <TableCell className="result">
          {getSkinsRowResult(skinsResults, hole, selectedScoreType, selectedRoundFormat)}
        </TableCell>
        <TableCell />
      </TableRow>
      <TableRow className="expandable-row" key={`hiddenTableRow-${index}`}>
        <TableCell
          className="inner-cell"
          colSpan={4}
          classes={{ root: 'leaderboard-row-event-summary' }}
        >
          <Collapse
            className={`collapse-${index}`}
            classes={{
              container: 'leaderboard-collapse',
              wrapperInner: 'leaderboard-collapse__wrapper-inner override'
            }}
            in={collapsedRow === index}
            timeout="auto"
            unmountOnExit={true}
          >
            {holeResults.map((player: any, expandedIndex: number) => (
              <div className="eliminated-player-row" key={`collapse-item-${expandedIndex}`}>
                {`${player.userFirstName[0]}. ${player.userLastName}`}
              </div>
            ))}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
